/* eslint-disable */
import {
	Accordion, AccordionDetails, AccordionSummary, Typography, Box
} from '@mui/material';
import { useMemo, useState } from 'react';
// import AdjustIcon from '@mui/icons-material/Adjust';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneIcon from '@mui/icons-material/Done';
import Lottie from 'lottie-react';
import styles from './IngredientAccordion.module.css';
import { classes, convertWeightUnit, getHigherUnitAndQuantity, getUnitConvertedQuantity, getUnitConvertedUnit } from '../../../../Helpers';
import correct from '../../../../Images/correct-lottie.json';
import wrong from '../../../../Images/wrong-lottie.json';
import MeasurementBox from '../../../../Components/Analytics/Quality/Measurement/MeasurementBox';
import { useAuth } from '../../../../Components/Auth/Login/auth';
import { TurnedIn } from '@mui/icons-material';

const style = {
	width: 50,
	height: 50,
};

function IngredientAccordion(props) {
	const { appConfig } = useAuth();
	const { measurement } = appConfig?.configs ?? {};
	const { key, ingredient, ingredientExpanded, setIngredient, isCms, itemFulfilled, unit, combineCMSBatches } = props;
	const [errorMsg, setErrorMsg] = useState('');


	const convertedConsumption = getUnitConvertedQuantity(ingredient?.consumption, ['count', 'pcs'].includes(ingredient?.unit) ? 'gram' : ingredient?.unit, true, true, true);
	const convertedConsumptionUnit = getUnitConvertedUnit(
		ingredient?.consumption,
		['count', 'pcs'].includes(ingredient?.unit) ? 'gram' : ingredient?.unit,
		true,
	);

	const convertedRequired = getUnitConvertedQuantity(
		ingredient?.requiredQty,
		['count', 'pcs'].includes(ingredient?.unit) ? 'gram' : ingredient?.unit,
		true,
		true,
		true
	);
	const convertedRequiredUnit = getUnitConvertedUnit(
		ingredient?.requiredQty,
		['count', 'pcs'].includes(ingredient?.unit) ? 'gram' : ingredient?.unit,
		true,
	);
	const convertedOrderd = getUnitConvertedQuantity(
		ingredient?.ingTotalQty,
		ingredient?.unit,
		true,
		true,
		true
	);
	const convertedOrderdUnit = getUnitConvertedUnit(
		ingredient?.ingTotalQty,
		ingredient?.unit,
		true
	);
	const weightUnit = getUnitConvertedUnit(
		ingredient?.minWeight,
		'kg',
		true
	);
	const perPeiceWeight = (ingredient?.consumption / ingredient?.piecesCount) || 0;

	const getColor = () => {
		if (perPeiceWeight < ingredient?.minWeight) {
			return {
				color: 'red',
				arrow: 'down',
			}
		}
		if (perPeiceWeight > ingredient?.maxWeight) {
			return {
				color: 'red',
				arrow: 'up',
			}
		}
		return {
			color: 'green',
		}
	};

	return (
		<div key={key}>
			<Accordion
				expanded={ingredientExpanded === ingredient?.id}
				onChange={() => {
					setIngredient(ingredient);
				}}
				className={classes(
					styles.root,
					ingredient?.isConsumed ? styles.completed : ''
				)}
			>
				<AccordionSummary
					className={styles['accordion-heading']}
					expandIcon={<ExpandMoreIcon />}
					aria-controls='panel1a-content'
					id='panel1a-header'
				>
					<div className={styles.heading}>
						<Typography
							variant='subtitle2'
							className={
								ingredient?.isConsumed
									? styles.completedText
									: styles.incomplete
							}
						>
							{ingredient?.name}
						</Typography>
						{ingredient?.isConsumed && (
							<>
								<DoneIcon className={styles['icon-selected']} />
								{ingredient?.overridden && (
									<div className={styles.overriden}>
										<InfoOutlinedIcon
											style={{
												color: 'red',
												paddingLeft: '1px',
											}}
										/>
										<span
											style={{
												color: 'rgb(240,0,0)',
											}}
										>
											Overridden
										</span>
									</div>
								)}
							</>
						)}
					</div>
					<p className={styles['consumed-weight']} style={{
						fontSize: '12px',
						whiteSpace: 'nowrap',
						marginRight: '4px',
					}}>
						{(isCms && combineCMSBatches)
							? (ingredientExpanded === ingredient?.id
								? null
								: (ingredient?.unit === 'count'
									? `${ingredient?.consumption ?? 0} pc/${ingredient?.ingTotalQty ?? 0} pc`
									: `${Number(convertedConsumption).toFixed(2) ?? 0}/${Number(convertedOrderd).toFixed(2) ?? 0} ${convertedConsumptionUnit}`))
							: `${convertedConsumption ?? 0} ${convertedConsumptionUnit ?? ''}`
						}
					</p>
				</AccordionSummary>
				<AccordionDetails className={styles['accordion-details']}>
					<div className={styles['expanded-div']}>
						<div
							className={styles.ingredientImage}
							style={(!ingredient?.image || errorMsg) ? {
								height: '320px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								backgroundColor: '#f5f5f5',
								borderRadius: '8px',
								border: '1px dashed #ccc'
							} : {}}
						>
							{ingredient?.image && !errorMsg ? (
								<img
									className={styles.image}
									alt='ig'
									src={ingredient?.image}
									onError={async () => {
										try {
											const res = await fetch(ingredient.image, { method: 'HEAD' });
											if (!res.ok) {
												setErrorMsg(`Error ${res.status}`);
											} else {
												setErrorMsg('Corrupted');
											}
										} catch (e) {
											setErrorMsg('Blocked/CORS');
										}
									}}
								/>
							) : (
								<div className='flex flex-col items-center gap-2'>
									<InfoOutlinedIcon style={{ fontSize: 40, color: '#999' }} />
									<Typography variant='caption' style={{ color: '#666' }}>
										{!ingredient?.image ? 'No Source' : errorMsg}
									</Typography>
								</div>
							)}

							<div className={styles.imagePassFail}>
								{ingredient?.imagePass !== null &&
									ingredient?.isConsumed &&
									(ingredient?.imagePass ? (
										<div className={styles.info}>
											<Lottie
												style={style}
												animationData={correct}
												loop
											/>
											<span> Ingredient Matched </span>
										</div>
									) : (
										<div className={styles.info}>
											<Lottie
												style={style}
												animationData={wrong}
												loop
											/>
											<span>
												{' '}
												Ingredient Mis-Matched
												{' '}
											</span>
										</div>
									))}
							</div>
							{ingredient?.qcTemp !== null && (!String(ingredient?.qcTemp).startsWith('120') && !String(ingredient?.qcTemp).startsWith('125')) && (
								<div className={styles.measure}>
									<MeasurementBox
										// modeIngredient={true}
										autoMode
										type='temp'
										qcDone
										cms
										height='43px'
										measurements={{
											min: ingredient?.minTemp ?? '-',
											max: ingredient?.maxTemp ?? '-',
											title: 'Temperature',
											measurement: [
												{
													size: 'md',
													value: ingredient?.qcTemp,
													color: 'black',
												},
											],
											result:
												(ingredient?.tempPass ?? null) &&
												(ingredient?.tempPass
													? 'PASS'
													: 'FAIL'),
											unit: measurement ? '°F' : '℃',
											connected: true,
											textToShow: 'Current Temp',
										}}
									/>
								</div>
							)}
						</div>
						{(isCms && combineCMSBatches)
							? (
								<MeasurementBox
									modeIngredient
									unit={unit}
									cms
									autoMode
									type='weight'
									qcDone
									hideMin={ingredient?.unit === 'count' ? false : true}
									hideMax={ingredient?.unit === 'count' ? false : true}
									measurements={{
										min: ingredient?.unit === 'count' ? `${ingredient?.minWeight} ${weightUnit}/pc` : null,
										max: ingredient?.unit === 'count' ? `${ingredient?.maxWeight} ${weightUnit}/pc` : null,
										title: 'Weight',
										showSubTitle: ingredient?.unit === 'count',
										subTitle: `${(Number(perPeiceWeight) || 0).toFixed(0)}g/pc`,
										calibration: ingredient?.unit === 'count' && ingredient?.calibrationWeight ? Math.floor(Number(ingredient?.calibrationWeight)) + 'g/pc' : null,
										colorBool: getColor(),
										measurement: [
											{
												size: 'lg',
												value: `${ingredient?.unit === 'count' ? (ingredient?.piecesCount || 0)
													+ ' pc' : (Number(convertedConsumption) || 0).toFixed(2)
													}/ ${ingredient?.unit === 'count' ? (ingredient?.ingTotalQty || 0) + ' pc' : `${(Number(convertedOrderd) || 0).toFixed(2)} ${convertedOrderdUnit}`}`,
												color: 'green',
											},
										],
										result:
											ingredient?.weightPass !== null &&
											(ingredient?.weightPass ? 'PASS' : 'FAIL'),
										// result:()?(ingredientData?.weightPass?"PASS":"FAIL"):null,
										unit: '',
										connected: true,
										textToShow: 'Packaged/Ordered',
									}}
								/>
							) : (
								<MeasurementBox
									modeIngredient
									cms
									autoMode
									type='weight'
									qcDone
									measurements={{
										min: getHigherUnitAndQuantity(
											['count', 'pcs'].includes(ingredient?.unit) ? 'gram' : ingredient?.unit,
											ingredient?.minWeight,
											true
										),
										max: getHigherUnitAndQuantity(
											['count', 'pcs'].includes(ingredient?.unit) ? 'gram' : ingredient?.unit,
											ingredient?.maxWeight,
											true
										),
										title: 'Weight',
										piecesCount: ingredient?.unit === 'count' || ingredient?.unit === 'pcs' ? `${(ingredient?.piecesCount || 0)} pc` : null,
										measurement: [
											{
												size: 'lg',
												value: `${`${convertedConsumption} ${convertedConsumptionUnit}` ?? '0'
													}/${convertedRequired}  ${convertedRequiredUnit}`,
												color: 'green',
											},
										],
										result:
											ingredient?.weightPass !== null &&
											(ingredient?.weightPass ? 'PASS' : 'FAIL'),
										// result:()?(ingredientData?.weightPass?"PASS":"FAIL"):null,
										unit: '',
										connected: true,
										textToShow: 'Consumed/Recommended',
									}}
								/>
							)}
					</div>
				</AccordionDetails>
			</Accordion>
		</div>
	);
}

export default IngredientAccordion;
